import React, { useEffect } from "react";
import styles from "./EmailForms.module.css";

import Textarea from 'rc-textarea';
import emailjs from 'emailjs-com';
import ScrollToTop from "../../helpers/ScrollToTop";

export const MediaRequestForm = (props) => {

    // props:
    // 
    // type = string, type of media

    // ----------------------------------------------------- STATE AND HOOKS
    let token = localStorage.getItem("token");
    
    // getting userID
    let tokenPeices = token.split(".");
    let idAndRole = atob(tokenPeices[1]);
    let userID = idAndRole.split(",")[0];


    useEffect(() =>{
        ScrollToTop();
    },[])
    // ----------------------------------------------------- PRE-RENDER
    // ----------------------------------------------------- RENDER

    return (
        <section className={styles.container}>
            <form className={styles.form}>
                <div className={styles.inputLableGroup}>
                    <input type="hidden" name="userID" className={styles.input} value={userID}/>
                </div>

                <div className={styles.inputLableGroup}>
                    <input type="hidden" name="type" className={styles.input} value={props.type}/>
                </div>

                <div className={styles.inputLableGroup}>
                    <label className={styles.label}>{props.type} Title</label>
                    <input type="text" name="title" className={styles.input} />
                </div>

                <div className={styles.inputLableGroup}>
                    <label className={styles.label}>{props.type} Creator</label>
                    <div className={styles.subtitle}>
                        optional
                    </div>
                    <input type="text" name="creator" className={styles.input} />
                </div>

                <div className={styles.inputLableGroup}>
                    <label className={styles.label}>Additional Details</label>
                    <div className={styles.subtitle}>
                        If there might be ambiguity, add clarifications here
                    </div>
                    <Textarea type="text" name="details" autoComplete="off" autoSize={{ minRows: 5 }} className={styles.input} />
                </div>

            </form>
        </section>
    )
}